<template>
  <footer>
    <b-container class="py-5 d-none d-md-block">
      <b-row>
        <b-col md="1">
          <b-img
            src="@/assets/logo.png"
            fluid-grow
            alt="logo image"
          ></b-img>
        </b-col>
        <b-col cols="6" md="3">
          <div class="footer-links">
            <p>Navigation</p>
            <ul>
              <li><router-link to="/">Home</router-link></li>
              <li><router-link to="/services">Services</router-link></li>
              <li><router-link to="/about">About</router-link></li>
              <li><router-link to="/contact">Contact</router-link></li>
            </ul>
          </div>
        </b-col>
        <b-col cols="6" md="4">
          <div class="footer-links">
            <p>Services</p>
            <ul>
              <li v-for="service in services" :key="service.id">
                <router-link to="/">{{ service.name }}</router-link>
              </li>
            </ul>
          </div>
        </b-col>
        <b-col md="4" class="d-none d-md-block">
          <div class="newsletter-form">
            <p>Join our newsletter for the latest updates!</p>
            <b-form netlify @submit="onSubmit">
              <b-form-group
                id="input-group-1"
                description="We'll never share your email with anyone else."
              >
                <b-form-input
                  id="input-1"
                  v-model="form.email"
                  type="email"
                  required
                  placeholder="Enter email"
                ></b-form-input>
              </b-form-group>
            </b-form>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </footer>
</template>

<script>
export default {
  name: "CustomFooter",
  data() {
    return {
      services: [
        {
          id: 1,
          name: "Web Design & Development",
          icon: "code",
          short_caption:
            "Web Design & Development Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent sit amet rutrum justo."
        },
        {
          id: 2,
          name: "Web Analytics",
          icon: "chart-bar",
          short_caption:
            "Web Analytics Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent sit amet rutrum justo."
        },
        {
          id: 3,
          name: "SEO Optimization",
          icon: "cogs",
          short_caption:
            "SEO Optimization Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent sit amet rutrum justo."
        },
        {
          id: 4,
          name: "Ads Management",
          icon: "ad",
          short_caption:
            "Ads Management Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent sit amet rutrum justo."
        },
        {
          id: 5,
          name: "Social Media Strategy",
          icon: "users",
          short_caption:
            "Social Media Strategy Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent sit amet rutrum justo."
        },
        {
          id: 6,
          name: "Graphic Design",
          icon: "pencil-ruler",
          short_caption:
            "Graphic Design Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent sit amet rutrum justo."
        }
      ],
      form: {
        email: ""
      }
    };
  },
  methods: {
    onSubmit(evt) {
      evt.preventDefault();
      alert(JSON.stringify(this.form));
    }
  }
};
</script>

<style lang="scss" scoped>
footer {
  color: $white;
  flex-shrink: 0;
  background-color: $dark-blue;

  svg {
    color: $light-blue;
    font-size: 25px;
  }
  .footer-links {
    p {
      color: $light-blue;
      font-weight: 500;
    }
    ul {
      padding: 0;
      li {
        list-style: none;
        a {
          color: $dark-grey;
          text-decoration: none;
        }
      }
    }
  }
  .newsletter-form {
    p {
      color: $dark-grey;
    }
    input {
      border-radius: 1.25rem;
    }
  }
}
</style>
